export const getUserName = user =>
  Object.keys(user).length > 0 ? `${user.name}, ${user.email}` : ''
